module.exports = __webpack_public_path__ + "static/placeholder-feature-1-5b020a70aa13a200d16af83284dc4ada.jpg";